import React from 'react'

import NewsAndAnnouncementsInfo from './NewsAndAnnouncements/NewsAndAnnouncementsInfo'

const CreateNewsAndAnnouncements: React.FC = () => {
  return <NewsAndAnnouncementsInfo />
}

export default CreateNewsAndAnnouncements
